import * as types from "./actionTypes";
import * as constants from "../constants/DomainConstants";
import mijnDossierApi from "../api/mijnDossierApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";


export function schaduwdossierResetFinishedLoading() {
	return {
		type: types.SCHADUWDOSSIER_RESET
	};
}

export function schaduwdossierLoaded(schaduwdossier) {
	return {
		type: types.SCHADUWDOSSIER_LOADED,
		body: schaduwdossier

	};
}

export function loadSchaduwdossier(dossierId) {
	return (dispatch) => {
		schaduwdossierResetFinishedLoading();
		dispatch(ajax.started());

		return mijnDossierApi.getSchaduwDossier(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(schaduwdossierLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
